

























import { Component, Vue } from "vue-property-decorator";
import ZhuanbingScale from "./components/zhuanbing-scale.vue";
import { upsertZhuanbingModule } from "./zhuanbing-content.service";

@Component({
  components: {
    ZhuanbingScale,
  },
})
export default class EditZhuanbingScale extends Vue {
  private score: number = 0;
  private answers: Record<string, number | null> = {};
  private initialAnswers: Record<string, number | null> = {};
  private diseaseName: string = "艾滋病免疫重建不全";
  private diseaseKey: string = "aizibing_mianyi_zhongjian_buquan";
  private checkId: string = "";

  private get patient() {
    return this.$store.state.patient;
  }

  private async created() {
    const fromQuery = this.$route.query.disease as string;
    if (fromQuery) {
      this.diseaseName = fromQuery;
    }
    const queryKey = this.$route.query.diseaseKey as string;
    if (queryKey) {
      this.diseaseKey = queryKey;
    }
    const queryCheckId = this.$route.query.checkId as string;
    if (queryCheckId) {
      this.checkId = queryCheckId;
    }
    this.initialAnswers = {};
    this.answers = {};
    this.score = 0;
  }

  private onScoreChange(score: number) {
    this.score = score;
  }

  private onAnswersChange(answers: Record<string, number | null>) {
    this.answers = { ...answers };
  }

  private async saveScale(showMessage: boolean = true) {
    const payload = {
      score: this.score,
      answers: this.answers,
      savedAt: Date.now(),
    };
    try {
      await upsertZhuanbingModule(this, {
        patientId: this.patient.id,
        diseaseName: this.diseaseName,
        diseaseKey: this.diseaseKey,
        checkId: this.checkId,
        moduleKey: "scale",
        moduleData: payload,
        loadingText: "保存专病积分量表…",
      });
      if (showMessage) {
        this.$message.success("保存成功");
      }
    } catch (e: any) {
      const msg = e?.message || "保存失败，请稍后重试";
      this.$message.error(msg);
      throw e;
    }
  }

  private async printPage() {
    await this.saveScale(false);
    this.$nextTick(() => {
      window.print();
    });
  }

  private goBack() {
    this.$router.back();
  }
}
